import { AxiosResponse } from "axios";

import BaseConverter from "shared/services/converters/baseConverter";

import { MediaModel, MediaResponse } from "shared/types";

export const convertMedia = (data: AxiosResponse<MediaResponse>): MediaModel[] => {
	return BaseConverter.convert<MediaResponse>(data)?.media;
};
